/* CO JE NOVÉHO / ČO JE NOVÉ — seznam vydání pro poradce (24. 10. 2026).
 *
 * PROČ: slovenský partner 23. 10. 2026: „Bolo by fajn mať školiace videá
 * k portálu, alebo aspoň info o zmenách a novinkách, ktoré prebehli.“
 * Stránka /novinky čte tenhle soubor, tečka v liště svítí, dokud poradce
 * nejnovější vydání neviděl (lib/novinky.js).
 *
 * JAK PŘIDAT VYDÁNÍ
 *   • nový objekt kamkoli do pole (stránka řadí sama, nejnovější nahoře),
 *   • datum ve tvaru RRRR-MM-DD (podle něj svítí tečka),
 *   • verze = CACHE_VERSION z public/service-worker.js toho vydání,
 *   • položka = { oblast, cs, sk, video }: oblast je klíč z OBLASTI níž,
 *     video je nepovinný odkaz https:// (prázdný = odkaz se neukáže).
 *
 * PRAVIDLA TEXTU: pro poradce, krátce, co se změnilo a kde to najde.
 * Žádný marketing, žádná čísla úspor, nic, co nejde ověřit v appce.
 * Ve slovenštině nesmí být ě, ř ani ů (hlídá lib/__tests__/skBezCestiny2026_10_19
 * i __tests__/novinky.test.js).
 */

/** Oblast appky → popisek štítku. */
export const OBLASTI = {
  klienti: { cs: "Klienti", sk: "Klienti" },
  analyza: { cs: "Analýza", sk: "Analýza" },
  nastroje: { cs: "Nástroje", sk: "Nástroje" },
  manazer: { cs: "Manažer", sk: "Manažér" },
  doporuceni: { cs: "Doporučení", sk: "Odporúčania" },
  slovensko: { cs: "Slovensko", sk: "Slovensko" },
};

export const NOVINKY = [
  {
    datum: "2026-10-19",
    verze: "v10.339.0-release-2026-10-19",
    polozky: [
      {
        oblast: "manazer",
        cs: "Moji poradci vidí každý, kdo má potvrzený tým, nejen manažer. V detailu poradce je jeho nábor a diář; diář jen tehdy, když to poradce povolí v Nastavení.",
        sk: "Moji poradcovia vidí každý, kto má potvrdený tím, nielen manažér. V detaile poradcu je jeho nábor a diár; diár len vtedy, keď to poradca povolí v Nastaveniach.",
        video: "",
      },
      {
        oblast: "analyza",
        cs: "Vysvětlivky pro poradce jsou schované pod „i“ vedle pole, zbytečné nápovědy zmizely.",
        sk: "Vysvetlivky pre poradcu sú schované pod „i“ vedľa poľa, zbytočné nápovedy zmizli.",
        video: "",
      },
      {
        oblast: "doporuceni",
        cs: "Stránka pro doporučení (odkaz, který klient pošle známým) má zase původní vzhled: jen jméno a telefon. Odměnu uvádí jen poradce.",
        sk: "Stránka pre odporúčanie (odkaz, ktorý klient pošle známym) má opäť pôvodný vzhľad: len meno a telefón. Odmenu uvádza len poradca.",
        video: "",
      },
      {
        oblast: "nastroje",
        cs: "Nástroje jsou bez karet skupin, každá kalkulačka má vlastní stránku.",
        sk: "Nástroje sú bez kariet skupín, každá kalkulačka má vlastnú stránku.",
        video: "",
      },
      {
        oblast: "nastroje",
        cs: "Historická kalkulačka ukazuje pásma krizí: jak hluboký byl propad a jak dlouho trval návrat.",
        sk: "Historická kalkulačka ukazuje pásma kríz: aký hlboký bol prepad a ako dlho trval návrat.",
        video: "",
      },
    ],
  },
  {
    datum: "2026-10-24",
    verze: "v10.340.0-release-2026-10-24",
    polozky: [
      {
        oblast: "klienti",
        cs: "Pipeline klientů: rychlé přidání klienta rovnou do zvolené fáze (výchozí je domluvená schůzka). Termín je nepovinný; když ho zadáte, zapíše se do diáře.",
        sk: "Pipeline klientov: rýchle pridanie klienta rovno do zvolenej fázy (predvolené je dohodnuté stretnutie). Termín je nepovinný; keď ho zadáte, zapíše sa do diára.",
        video: "",
      },
      {
        oblast: "klienti",
        cs: "Stopa v pipeline má nad tečkami názvy fází. Klik na tečku fázi naplánuje v diáři: vyberete den a čas, klientovi se zapíše datum fáze. Fáze se posouvá jen dopředu, nikdy zpět.",
        sk: "Stopa v pipeline má nad bodkami názvy fáz. Klik na bodku naplánuje fázu v diári: vyberiete deň a čas, klientovi sa zapíše dátum fázy. Fáza sa posúva len dopredu, nikdy späť.",
        video: "",
      },
      {
        oblast: "analyza",
        cs: "Tisk analýzy je shrnutí schůzky pro klienta: co je pro něj důležité, cíle, co budeme řešit, podklady a další krok. Prázdné sekce se netisknou a dole je vždy upozornění, že jde o nezávazný podklad.",
        sk: "Tlač analýzy je zhrnutie stretnutia pre klienta: čo je pre neho dôležité, ciele, čo budeme riešiť, podklady a ďalší krok. Prázdne sekcie sa netlačia a dole je vždy upozornenie, že ide o nezáväzný podklad.",
        video: "",
      },
      {
        oblast: "nastroje",
        cs: "Kalkulačky z boční lišty v analýze se vejdou na obrazovku bez rolování, podrobné karty jsou pod „i“. Na telefonu se roluje jako dřív.",
        sk: "Kalkulačky z bočnej lišty v analýze sa zmestia na obrazovku bez posúvania, podrobné karty sú pod „i“. Na telefóne sa posúva ako predtým.",
        video: "",
      },
      {
        oblast: "slovensko",
        cs: "Slovenská verze: doplněné překlady (mimo jiné tisk analýzy) a u slovenského účtu na dalších místech € místo Kč. Opravy pokračují.",
        sk: "Slovenská verzia: doplnené preklady (okrem iného tlač analýzy) a pri slovenskom účte na ďalších miestach € namiesto Kč. Opravy pokračujú.",
        video: "",
      },
    ],
  },
];
